import React from "react";
import PropTypes from 'prop-types';
import MaskedInput from 'react-text-mask';
import { TextField } from "@material-ui/core";

import '../../../../styles.css';

function TextMaskCustom(props) {
    const { inputRef, ...other } = props;
    return (
        <MaskedInput
            {...other}
            ref={(ref) => {
                inputRef(ref ? ref.inputElement : null);
            }}
            mask={['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
            showMask
        />
    );
}

function TextMaskCustomCel(props) {
    const { inputRef, ...other } = props;
    return (
        <MaskedInput
            {...other}
            ref={(ref) => {
                inputRef(ref ? ref.inputElement : null);
            }}
            mask={['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
            showMask
        />
    );
}

export default function BasicInfo(props) {
    const handleChange = (event) => {
        props.setValues({
            ...props.values,
            [event.target.id]: event.target.value,
        });
        console.log(event.target.id)
    };

    return (
        <>
            <div className="titles">Informações Gerais</div>
            <div className="fundo">
                <div className="rowForm">
                    <div className="auto6">
                        <TextField
                            id="nome"
                            margin="dense"
                            label="Nome Completo"
                            value={props.values.nome}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="auto6">
                        <TextField
                            id="especialidade"
                            margin="dense"
                            label="Especialidade"
                            value={props.values.especialidade}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="auto6">
                        <TextField
                            id="cidade"
                            margin="dense"
                            label="Cidade"
                            value={props.values.cidade}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                <div className="rowForm">
                    <div className="auto6">
                        <TextField
                            margin="dense"
                            id="telefone1"
                            label="Telefone 1"
                            onChange={handleChange}
                            value={props.values.telefone1}
                            InputProps={{ inputComponent: TextMaskCustom }}
                        />
                    </div>

                    <div className="auto6">
                        <TextField
                            margin="dense"
                            id="telefone2"
                            label="Telefone 2"
                            onChange={handleChange}
                            value={props.values.telefone2}
                            InputProps={{ inputComponent: TextMaskCustom }}
                        />
                    </div>


                    <div className="auto6">
                        <TextField
                            margin="dense"
                            id="celular"
                            label="Celular/WhatsApp"
                            onChange={handleChange}
                            value={props.values.celular}
                            InputProps={{ inputComponent: TextMaskCustomCel }}
                        />
                    </div>
                </div>

                <div className="rowForm">
                    <div className="auto6">
                        <TextField
                            id="email_principal"
                            type="email"
                            margin="dense"
                            label="E-mail Principal"
                            disabled={props.update === true ? true : false}
                            value={props.values.email_principal}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="auto6">
                        <TextField
                            id="email"
                            type="email"
                            margin="dense"
                            label="E-mail"
                            disabled={props.update === true ? true : false}
                            value={props.values.email}
                            onChange={handleChange}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

BasicInfo.propTypes = {
    update: PropTypes.bool,
    values: PropTypes.object,
    setValues: PropTypes.func
};
